import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon: any = styled(BaseSvg)`
  width: 16px;
  height: 16px;
  color: #1a56db;
`

const AddCircle = ({ title = 'Add', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 16 16" title={title} {...rest}>
    <g transform="translate(1 1)" stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="square">
      <path d="M7 3.957v6.086M10.043 7H3.957" />
      <circle cx={7} cy={7} r={6.696} />
    </g>
  </StyledIcon>
)

AddCircle.needsWork = true
AddCircle.displayName = 'AddCircleIcon'

export default AddCircle
